import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: 32,
  },
  root: {
    'padding': 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  wrap: {
    // width: 360,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 4,
    marginTop: theme.spacing(5)
  },
  label: {
    marginBottom: theme.spacing(2),
    fontSize: 14,
  },
}));

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={
        <Button variant="contained" color="primary">
          {props.value}
        </Button>
      }
      icon={
        <Button variant="outlined" color="default">
          {props.value}
        </Button>
      }
      {...props}
    />
  );
}

const InvolvementInput = ({ label, value, ...other }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography className={classes.label}>
        {label}
      </Typography>
      <Grid container>
        <Grid item sm={12}  md={12} lg={12}>
          <div className={classes.wrap}>
            <StyledRadio value={1} checked={value === '1'} {...other} />
            <StyledRadio value={2} checked={value === '2'} {...other} />
            <StyledRadio value={3} checked={value === '3'} {...other} />
            <StyledRadio value={4} checked={value === '4'} {...other} />
            <StyledRadio value={5} checked={value === '5'} {...other} />
          </div>
          <div className={classes.wrap}>
            <Typography variant="caption" color="textSecondary">
              Very Involved
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Hardly Involved
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default InvolvementInput;
